import React, { useEffect } from 'react';
import SinglePane from '../SinglePane';
import { usePaneViewer } from '../PaneViewer';
import { Button, Flex } from '@smarterservices/smarter-ui';
import StepInstructions from '../Common/StepInstructions';
import { useAppStore } from '../../stores/app';
import { sendMessageToExtension } from '../../helpers/helpers';

const ReconnectIntro = ({ stepData, setIsTaskComplete }) => {
  const [renderStep, setRenderStep] = React.useState(false);
  const { apiClient } = useAppStore();
  const { onNext } = usePaneViewer();
  useEffect(() => {
    // show the next button right away
    const initalizeReconnect = async () => {
      const sessionData = await apiClient.getSession();
      const allowAttempt = sessionData?.series?.reconnection?.allowAttempt;
      setRenderStep(allowAttempt);
      if (!allowAttempt) {
        const popup = {
          body: 'Session Ended',
          reason: 'The maximum number of reconnect attempts has been reached for this session.',
        }
        await sendMessageToExtension({
          message: 'sp_background__endSession',
          disconnectReason: 'virtual-agent-ended',
          popup,
        });
      }
      setIsTaskComplete(true);
    }
    initalizeReconnect();
  }, []);

  return (
    <>
      {stepData && renderStep && (
        <SinglePane>
          <Flex direction="column" height="100%" justifyContent="center" alignItems="center" gap="medium">
            <StepInstructions instructions={stepData?.body} />
            <Button
              color="primary"
              onClick={onNext}
              margin="0 small"
            >
              Next
            </Button>
          </Flex>
        </SinglePane>
      )}
    </>
  );
};

export default ReconnectIntro;
